/**
 * Limit a rating to between 0 and 100.
 *
 * @memberOf core.player
 * @param {number} rating Input rating.
 * @return {number} If rating is below 0, 0. If rating is above 100, 100. Otherwise, rating.
 */
const limitRating = (rating: number, maxRating = 100): number => {
	if (rating > maxRating) {
		return maxRating;
	}

	if (rating < 0) {
		return 0;
	}

	return Math.floor(rating);
};

export default limitRating;
